<template>
    <div :class="['page contact-us',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content" :style="{  backgroundColor: backgroundColor, color: fontColor }">
            <img :src="contactUs" style="width: 100%" />
            <div class="label">
                <textarea placeholder="Your Message..." v-model="message"></textarea>
            </div>
            <p class="btn" @click="send" :style="{ backgroundColor: btnColor, color: btnFontColor }">SEND</p>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import Alert from '@/utils/Alert.js'

export default {
    name: 'contact-us',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    computed: {
        member () { var state = this.$store.state; return { _id: state.auth._id, name: state.name, email: state.email, customerNo: state.customerNo, phone: state.phone } },
        client_id () { return this.$store.state.client_id },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor }, 
        contactUs () { return this.$store.state.contactUs }       
    },
    data () {
        return {
            name: '',
            email: '',
            message: ''
        }
    },
    mounted () {
        this.name = this.member.name;
        this.email = this.member.email;
    },
    methods: {
        send () {
         this.pageOn = false;
         WebSoc.SEND({ t: 'sendContactUs', data: { client_id: this.client_id, member: this.member, name: this.name, email: this.email, message: this.message } },() => {
            
         });
         Alert.message('Thank you for contacting us.<br>One of our team will get back to you as soon as they can.');
        }
    }
}

</script>

<style lang="scss">
.contact-us {
    h1,h2 { font-weight: 300; text-align: center; }
    h1 { color: $font-color; margin-top: 30px; }
    .label {
        > p { margin-bottom: -5px; color: white; }
        input { width: calc(100% - 50px); }
        textarea {
            width: calc(100% - 50px);
            margin: 10px 15px;
            min-height: 200px;
            font-size: 20px;
            padding: 10px;
        }
    }
}
</style>